import { usePageEventsTracker } from '@infl-ts/util-page-events-tracker';
import { useEffect } from 'react';
import { challengePages, onboardingCategories } from './constants';
export var useTrackOnboardingChallengeCompleted = function useTrackOnboardingChallengeCompleted(_ref) {
  var skip = _ref.skip;

  var _usePageEventsTracker = usePageEventsTracker(),
      startActivity = _usePageEventsTracker.startActivity;

  useEffect(function () {
    if (skip) return;
    return startActivity(onboardingCategories.challenge, challengePages.completion);
  }, [skip]);
};